import React, { Fragment } from 'react';
import { AndroidPromotionBanner } from './AndroidPromotionBanner';
import { useAndroidBanner } from './useAndroidBanner';
import { jsx as _jsx } from "react/jsx-runtime";
export const AppPromotionBanner = () => {
  const androidBanner = useAndroidBanner();
  return /*#__PURE__*/_jsx(Fragment, {
    children: androidBanner && /*#__PURE__*/_jsx(AndroidPromotionBanner, {
      androidBanner: androidBanner
    })
  });
};